import { formatDob } from '../utils/dobFormatter'

export default function(store, { host }) {
  const PatientContact = store.defineModel('patientContact', {
    replaceKeys: {
      patientDob: 'dob',
      patientGender: 'gender',
      patientMrn: 'mrn',
      relationName: 'relation',
    },

    parseAttrs(attrs) {
      if ('entity' in attrs) delete attrs['entity']

      if ('dob' in attrs) {
        attrs.dob = formatDob(attrs.dob)
      }

      return attrs
    },

    relations: {
      belongsTo: {
        patient: { type: 'patient', foreignKey: 'patientId' },
        user: { type: 'user', foreignKey: 'userId' },
      },
    },
  })

  return PatientContact
}
